import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getQueryParamIgnoreCase } from '../../utilFuncs/utilFuncs';

type SortingOption = string;

export interface SortingViewPriceState {
  selectedSortingOptionViewPrice: SortingOption;
  isOpen: boolean;
}

function getFromUrlParams(): 'person' | 'cabin' {
  const viewPrice = getQueryParamIgnoreCase(window.location.search, 'viewPrice');

  if (!viewPrice || (viewPrice !== 'person' && viewPrice !== 'cabin')) {
    return 'person';
  }

  return viewPrice;
}

const initialState: SortingViewPriceState = {
  selectedSortingOptionViewPrice: getFromUrlParams(),
  isOpen: false,
};

const sortingViewPriceSlice = createSlice({
  name: 'sortingViewPrice',
  initialState,
  reducers: {
    setSelectedSortingOptionViewPrice: (state, action: PayloadAction<SortingOption>) => {
      state.selectedSortingOptionViewPrice = action.payload;
    },
    toggleDropdownViewPrice: (state) => {
      state.isOpen = !state.isOpen;
    },
  },
});

export const { setSelectedSortingOptionViewPrice, toggleDropdownViewPrice } =
  sortingViewPriceSlice.actions;
export default sortingViewPriceSlice.reducer;
